// 文字数制限まわりの共通処理（char_counter.js と form_errors.js で共用）

export const FIELD_SELECTOR = '[data-char-limit]';
export const FOOTER_CLASS = 'c-field-footer';
export const COUNTER_CLASS = 'c-char-counter';
export const ERROR_CLASS = '-error';

// サーバー側の TextLengthValidator と同じ数え方（改行は1文字、絵文字などのサロゲートペアも1文字）
export const countChars = function(value) {
  return Array.from(value.replace(/\r\n/g, '\n')).length;
};

export const charLimitOf = function(field) {
  return Number(field.dataset.charLimit);
};

export const isOverLimit = function(field) {
  return countChars(field.value) > charLimitOf(field);
};

export const isVisible = function(element) {
  return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};

// 入力欄の下の行（ApplicationHelper#field_footer が出力）。
// 入力欄の直後か、入力欄を包む要素（.c-textarea など）の直後にある。見つからない場合は作る。
export const footerFor = function(field) {
  const candidates = [field.nextElementSibling, field.parentElement && field.parentElement.nextElementSibling];
  for (let i = 0; i < candidates.length; i++) {
    if (candidates[i] && candidates[i].classList.contains(FOOTER_CLASS)) return candidates[i];
  }

  const footer = document.createElement('div');
  footer.className = FOOTER_CLASS;
  field.insertAdjacentElement('afterend', footer);
  return footer;
};

export const childOfFooter = function(field, className, position) {
  const footer = footerFor(field);
  let element = footer.querySelector('.' + className);
  if (!element) {
    element = document.createElement('span');
    element.className = className;
    if (position === 'first') {
      footer.insertAdjacentElement('afterbegin', element);
    } else {
      footer.appendChild(element);
    }
  }
  return element;
};
